export interface Column {
  key: string;
  label: string;
  sortable?: boolean;
  width?: string;
}

export const ROW_HEIGHT = 41;

export const columns: Column[] = [
  { key: 'amount',       label: 'Monto',      sortable: true,  width: '130px' },
  { key: 'status',       label: 'Estado',     sortable: true,  width: '130px' },
  { key: 'arrival_date', label: 'Depósito',   sortable: true,  width: '150px' },
  { key: 'bank',         label: 'Banco',      sortable: false, width: 'auto'  },
];